import React, { useState } from "react";
import Img1 from "../assets/mahavi/Mahavidyalaya_page-0001.jpg";
import Img2 from "../assets/mahavi/Mahavidyalaya_page-0002.jpg";
import Img3 from "../assets/mahavi/Mahavidyalaya_page-0003.jpg";
import Img4 from "../assets/mahavi/Mahavidyalaya_page-0004.jpg";
import Img5 from "../assets/mahavi/Mahavidyalaya_page-0005.jpg";
import Img6 from "../assets/mahavi/Mahavidyalaya_page-0006.jpg";
import Img7 from "../assets/mahavi/Mahavidyalaya_page-0007.jpg";
import Img8 from "../assets/mahavi/Mahavidyalaya_page-0008.jpg";
import DC from "../assets/Mahavidyalaya.pdf";
import PageHeader from "./PageHeader";

const MahaVidyalayeCommittee = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8];

  const closeModal = () => setSelectedImage(null);

  return (
    <>
      <PageHeader title="Mahavidyalaya Committee" />

      <div style={styles.container}>
        {/* PDF Download Button */}
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <a href={DC} download="Mahavidyalaya.pdf" style={styles.downloadBtn}>
            📄 Download Full PDF
          </a>
        </div>

        {/* Image Grid */}
        <div style={styles.grid}>
          {images.map((img, index) => (
            <div key={index} style={styles.card}>
              <img
                src={img}
                alt="Committee"
                style={styles.image}
                onClick={() => setSelectedImage(img)}
              />
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedImage && (
          <div style={styles.modalOverlay} onClick={closeModal}>
            <div
              style={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <button style={styles.closeBtn} onClick={closeModal}>
                ✕
              </button>

              <img
                src={selectedImage}
                alt="Preview"
                style={styles.modalImage}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "30px",
    maxWidth: "1200px",
    margin: "auto",
  },

  /* ===== GRID FIXED 4 PER ROW DESKTOP ===== */
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "20px",
  },

  card: {
    overflow: "hidden",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    cursor: "pointer",
  },

  image: {
    width: "100%",
    height: "250px",
    objectFit: "cover",
    transition: "0.3s",
  },

 
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "20px",
  },

  modalContent: {
    position: "relative",
   
    borderRadius: "12px",
    maxWidth: "1000px",
    width: "100%",
    maxHeight: "100vh",
    overflow: "auto",
    textAlign: "center",
  },

  modalImage: {
    width: "100%",
    maxHeight: "100vh",
    objectFit: "contain",
  },

  closeBtn: {
    position: "absolute",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    top: "10px",
    right: "0px",
    backgroundColor: "gray",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  downloadBtn: {
    display: "inline-block",
    padding: "12px 25px",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "6px",
    fontWeight: "bold",
  },
};

export default MahaVidyalayeCommittee;